export default {
    SET_DECLARE(state,declareCompany){
        state.declareCompany = declareCompany
    },
    SET_BIRTH_COUNTRY_DIRECTOR(state,birthCountryDirector) {
        state.birthCountryDirector = birthCountryDirector
    }
}